/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator'
import { inject } from 'inversify-props'
import API from '@core/services/API'
import AppForm from '@core/components/AppForm.vue'
import { IDateService } from '@master/services/IDateService'
import { FormStructure } from '@master/model/structure/FormStructure'
import { namespace } from 'vuex-class'
import { ClientDto } from '@core/pages/client-management/api'

const clientInfoStore = namespace('ClientInfoStore')

@Component({
  components: {
    AppForm
  }
})
export class F2FVerifyMixin extends Vue {
  @inject()
  protected dateService: IDateService

  @inject()
  protected $api: API

  @clientInfoStore.State
  private clientDto: ClientDto

  @clientInfoStore.State
  private readOnly

  formattedDate (unixTime: number | string) {
    return this.dateService.format(Number(unixTime), 'YYYY-MM-DD')
  }

  get curUser () {
    return this.$store.getters.currentUser
  }

  get isSuperUser () {
    return this.curUser?.isSuperUser || false
  }

  get policyOid () {
    return this.$route.params.policyOid
  }

  get clientOid () {
    return this.$route.params.clientOid
  }

  get f2fStructure (): FormStructure<ClientDto> {
    return [
      {
        label: 'Date of Verification',
        key: 'ftfDateOfVerification',
        type: 'date'
      },
      {
        label: 'Performed By',
        key: 'ftfPerformedBy'
      },
      {
        label: 'Job Role',
        key: 'ftfJobRole'
      },
      {
        label: 'Remarks',
        key: 'ftfRemarks',
        type: 'textarea',
        classes: ['colspan']
      }
    ]
  }
}
